export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "守护甜心一共有多少集？正确的观看顺序是什么？",
    a: "守护甜心动画系列共分为三部：第一部《守护甜心！》51 集，第二部《守护甜心！！心跳》51 集，第三部《守护甜心！派对》25 集，合计约 127 集。推荐按照第一、二、三部的顺序观看，剧情衔接最流畅。",
  },
  {
    q: "守护甜心的世界观是什么？守护蛋是什么？",
    a: "在守护甜心的世界里，每个孩子心中『理想中的自己』会凝结成一颗守护蛋，当心愿足够强烈时就会孵出守护甜心，成为并肩作战的伙伴。如果孩子否定自己或放弃梦想，守护蛋就会变成 X 蛋。",
  },
  {
    q: "亚梦最后和谁在一起了？",
    a: "守护甜心系列并没有给出一锤定音的恋爱结局。亚梦与几斗、唯世之间的感情线始终是作品的重要看点，结局更侧重于亚梦在守护他人与接纳自我的过程中获得成长，留给观众开放的想象空间。",
  },
  {
    q: "亚梦的三个守护甜心分别是谁？",
    a: "分别是代表运动与活力的小兰、代表艺术与审美的美琪，以及代表温柔与照顾的小丝。她们分别对应亚梦性格中三个常被隐藏的侧面，共同拼出一个完整的亚梦。",
  },
  {
    q: "X 蛋（坏蛋）和守护蛋有什么关系？",
    a: "X 蛋是被污染、画上大叉的守护蛋，它并非怪物，而是主人被忽视的真心在求救。守护者的使命不是打败 X 蛋，而是用理解与拥抱将其净化，让它回到主人的心里。",
  },
];